var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.isDevEnv ? { '--env-banner-height': '20px' } : {})},[(_vm.isDevEnv)?_c('env-banner'):_vm._e(),(!_vm.isLoggedIn && !_vm.$route.meta.isPublic)?_c('login-view'):_c('v-main',[_c('router-view'),_c('snackbar'),_c('feature-search')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }